
<modal
  title="Create New Collection"
  :open="open"
  @close="closeModal"
>
  <form @submit.stop.prevent="submit">
    <text-input
      v-model.trim="name"
      label="Collection Name"
      maxlength="50"
    />

    <div class="button-row">
      <btn
        type="submit"
        :loading="submitting"
        :disabled="disabled"
        loading-text="Submitting"
      >
        Create
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </div>
  </form>
</modal>
